/**
 * Admin catalogue: show copy as "English (Arabic)" when both languages differ.
 */
export function formatEnAr(en: string | undefined | null, ar: string | undefined | null): string {
  const e = (en ?? '').trim();
  const a = (ar ?? '').trim();
  if (!e && !a) return '';
  if (!a) return e;
  if (!e) return a;
  if (e === a) return e;
  return `${e} (${a})`;
}

type ProductLocaleFields = {
  en?: { title?: string; shortDescription?: string; fullDescription?: string };
  ar?: { title?: string; shortDescription?: string; fullDescription?: string };
};

export function formatProductLocaleField(
  base: string | undefined,
  locale: ProductLocaleFields | undefined,
  field: 'title' | 'shortDescription' | 'fullDescription',
): string {
  const en = (locale?.en?.[field] ?? base ?? '').trim();
  const ar = (locale?.ar?.[field] ?? '').trim();
  return formatEnAr(en, ar);
}

export function formatPackageLocaleFields(pkg: {
  title: string;
  subTitle?: string;
  locale?: {
    en?: { title?: string; subTitle?: string };
    ar?: { title?: string; subTitle?: string };
  };
}): { title: string; subTitle?: string } {
  const title = formatEnAr(
    (pkg.locale?.en?.title ?? pkg.title ?? '').trim(),
    (pkg.locale?.ar?.title ?? '').trim(),
  );
  const subEn = (pkg.locale?.en?.subTitle ?? pkg.subTitle ?? '').trim();
  const subAr = (pkg.locale?.ar?.subTitle ?? '').trim();
  const subTitle = formatEnAr(subEn, subAr);
  return {
    title,
    ...(subTitle ? { subTitle } : {}),
  };
}

export function formatOptionOrItemLabel(
  base: string | undefined,
  locale: { en?: { label?: string }; ar?: { label?: string } } | undefined,
): string {
  return formatEnAr(
    (locale?.en?.label ?? base ?? '').trim(),
    (locale?.ar?.label ?? '').trim(),
  );
}
